import React from 'react'
import classNames from 'classnames'
import './index.less'

export default ({ label, message, isRules }) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
    {
      label ? <div className="mn-rule-wrapper">
        {label}
        <span className={classNames({ 'mn-rule-label': isRules })}>&nbsp;*&nbsp;{isRules && message}</span>
      </div> : <span className={classNames({ 'mn-rule-label': isRules })}>&nbsp;*&nbsp;{isRules && message}</span>
    }
  </>
)
